
import BusBookingMain from "../../components/bus-booking-report/BusBookingMain"

export const BusBookingReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <BusBookingMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}